export const FileEditDialogTitle = {
  add: 'ファイル新規登録',
  update: 'ファイル編集',
};
